import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ascpost-surgical',
  templateUrl: './ascpost-surgical.component.html',
  styleUrls: ['./ascpost-surgical.component.css']
})
export class AscpostSurgicalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
